module.exports = __webpack_public_path__ + "img/1-7eleven-img.ac9223a3.png";